// extracted by mini-css-extract-plugin
export default {"tableActions":"TableActions__tableActions-_zmH0"};